module.exports = __webpack_public_path__ + "img/icon_pormo.63f7f0b.webp";